document.addEventListener("DOMContentLoaded", function () {
  console.log('test')
  const $carousel = $(".carousel-alt");

  const $items = $carousel.children();
  const itemCount = $items.length;

  $carousel.on("init", function (event, slick) {
    slick.$slider.css("visibility", "visible");
  });

  $carousel.slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: "linear",
    infinite: true,
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    draggable: false,
    swipe: false,
    touchMove: false,
    waitForAnimate: false,
  });

  // Custom infinite loop handling
  $carousel.on("afterChange", function (event, slick, currentSlide) {
    if (currentSlide >= itemCount) {
      $carousel.slick("slickGoTo", currentSlide - itemCount, true);
    }
  });
});
